import { outerLayoutMixinPropsType, } from "../../mixins/outerLayout";
export const formControlContainerPropsType = outerLayoutMixinPropsType.complete({
    className: true,
    label: true,
    labelHtmlFor: true,
    isOptional: true,
    errorMessage: true,
    infoMessage: true,
    labelOnClick: true,
    labelAdditionalContent: true,
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9Gb3JtQ29udHJvbENvbnRhaW5lci90eXBlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxPQUFPLEVBRUwseUJBQXlCLEdBQzFCLE1BQU0sMEJBQTBCLENBQUM7QUFpQ2xDLE1BQU0sQ0FBQyxNQUFNLDZCQUE2QixHQUN4Qyx5QkFBeUIsQ0FBQyxRQUFRLENBQTRCO0lBQzVELFNBQVMsRUFBRSxJQUFJO0lBQ2YsS0FBSyxFQUFFLElBQUk7SUFDWCxZQUFZLEVBQUUsSUFBSTtJQUNsQixVQUFVLEVBQUUsSUFBSTtJQUNoQixZQUFZLEVBQUUsSUFBSTtJQUNsQixXQUFXLEVBQUUsSUFBSTtJQUNqQixZQUFZLEVBQUUsSUFBSTtJQUNsQixzQkFBc0IsRUFBRSxJQUFJO0NBQzdCLENBQUMsQ0FBQyJ9